import React, { useState, useCallback } from 'react';

import { assignJourneyOwner } from 'modules/tasks/http';
import { useSelectedTasksContext } from 'modules/tasks/lists/context';
import {
  useAssignOwnerContext,
  closeAssignOwnerModal,
  selectAgentAssignOwnerModal,
} from 'modules/tasks/assign-owner/context';

import AssignAgentModal from 'modules/journey/AssignAgentModal/component';

const t = {
  assign: 'Assign',
  job: 'job',
  jobs: 'jobs',
};

const AssignOwnerModal = () => {
  const [loading, setLoading] = useState(false);
  const { state, dispatch } = useAssignOwnerContext();
  const { modalStatus, agent, journeyIds } = state || {};
  const { setSelected, setSelectAllEnabled } = useSelectedTasksContext();

  const modalTitle = `${t.assign} ${journeyIds?.length} ${journeyIds?.length > 1 ? t.jobs : t.job}`;

  const handleAssignJourneys = useCallback(async () => {
    setLoading(true);
    await assignJourneyOwner({ ids: journeyIds, agentId: agent.value });
    setLoading(false);
    setSelected([]);
    setSelectAllEnabled({
      NOT_ATTENDED: false,
      KEEP_AN_EYE: false,
    });
    dispatch(closeAssignOwnerModal());
  }, [journeyIds, setSelectAllEnabled, setSelected, agent, dispatch]);

  const handleSelectOwner = useCallback(
    (val) => {
      const { agent } = val || {};

      dispatch(selectAgentAssignOwnerModal({ agent: { label: agent?.name, value: agent?.id } }));
    },
    [dispatch]
  );

  const handleClose = useCallback(() => {
    dispatch(closeAssignOwnerModal());
  }, [dispatch]);

  return (
    <AssignAgentModal
      title={modalTitle}
      show={modalStatus === 'open'}
      selectedAgent={agent}
      onAssign={handleAssignJourneys}
      onSelect={handleSelectOwner}
      onClose={handleClose}
      loading={loading}
    />
  );
};

export default AssignOwnerModal;
